/**
 * P3 SP1 — composes the lens snapshot the visibility predicate consumes:
 * lens state + the session's defaultTrailId (legacy-null rule). Null when
 * no LensProvider (admin/work surfaces) — callers treat null as all-on.
 * THE single producer of LensSnapshot; SP2's canvas imports this too.
 */
import { useContext, useMemo } from 'react';

import { LensContext } from '../contexts/LensContext';
import type { LensSnapshot } from '../utils/lensVisibility';
import { useDefaultTrailId } from './useDefaultTrailId';

export function useLensSnapshot(): LensSnapshot | null {
  const lens = useContext(LensContext);
  const defaultTrailId = useDefaultTrailId();
  return useMemo(() => lens ? ({
    mode: lens.mode, activePersonaIds: lens.activePersonaIds,
    activeTrailId: lens.activeTrailId, defaultTrailId,
  }) : null, [lens?.mode, lens?.activePersonaIds, lens?.activeTrailId, defaultTrailId, lens]);
}
